// This couldn't be in storage.js because it would create a circular dependency with debug.js
export var updateStorage = function(storageArea, key, newValue) {
    var oldValue = storageArea.getItem(key);
    if (newValue !== oldValue) {
        if (newValue === null) {
            storageArea.removeItem(key);
        } else {
            storageArea.setItem(key, newValue);
        }
        window.dispatchEvent(new StorageEvent("storage", {
            key: key,
            newValue: newValue,
            oldValue: oldValue,
            storageArea: storageArea
        }));
    }
};

//# sourceMappingURL=storage-utils.js.map